import { render, staticRenderFns } from "./News.vue?vue&type=template&id=ec9404dc&scoped=true&lang=pug"
import script from "./News.vue?vue&type=script&lang=ts"
export * from "./News.vue?vue&type=script&lang=ts"
import style0 from "./News.vue?vue&type=style&index=0&id=ec9404dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9404dc",
  null
  
)

export default component.exports